// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._5c5zF3t4x{background-color:var(--action-list);border-radius:2px;cursor:pointer;margin:2px 0;position:relative}@media screen and (-ms-high-contrast: active){._5c5zF3t4x:focus{outline:2px dotted buttonText;outline-offset:1px}}._5c5zF3t4x:hover{background-color:var(--action-list-hover)}@media screen and (-ms-high-contrast: active){._5c5zF3t4x:hover{border:1px solid highlight}._5c5zF3t4x:hover ._76ezpGXBx{color:highlight}._5c5zF3t4x:hover ._1K0djn6Tx path{fill:highlight}}@media screen and (-ms-high-contrast: active){._5c5zF3t4x{border:1px solid buttonText}}._2LPIfHenx{display:flex;align-items:center;padding-left:3px}._2LPIfHenx ._76ezpGXBx{padding-left:13px}._6yVyVrdLx{padding:8px 0 8px 4px}._6yVyVrdLx ._76ezpGXBx{padding-left:16px}._76ezpGXBx{margin:0;color:var(--link-text)}@media screen and (-ms-high-contrast: active){._76ezpGXBx{color:buttonText}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"row": "_5c5zF3t4x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus"] + "",
	"text": "_76ezpGXBx",
	"icon": "_1K0djn6Tx",
	"container": "_2LPIfHenx",
	"large-container": "_6yVyVrdLx _2LPIfHenx",
	"largeContainer": "_6yVyVrdLx _2LPIfHenx"
};
module.exports = exports;
